import { auth } from "../../firebaseConfig";

// ID token de la sesión actual para sg-realtime (/reporting y el socket), que
// lo verifica y exige users/{uid}.canUseSG. Una llave fija no sirve aquí:
// quedaría en el bundle. getIdToken() lo renueva solo cuando está por vencer
// (dura 1 h).
//
// authStateReady: al abrir /sg directo, la primera petición salía antes de que
// Firebase restaurara la sesión (currentUser null) y se iba sin token; el log
// de sg-realtime lo muestra el 28-oct-2026 (system.dumaxst.com → /origins
// «sin credencial»). Con la llave obligatoria esa carga se quedaba sin datos.
export async function sgRealtimeIdToken(): Promise<string | undefined> {
  await auth.authStateReady();
  return auth.currentUser?.getIdToken();
}

export async function sgRealtimeAuthHeaders(): Promise<Record<string, string>> {
  const token = await sgRealtimeIdToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
